import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import FeaturedPlayer from "./components/FeaturedPlayer";
import Rankings from "./components/Rankings";
import Spotlight from "./components/Spotlight";
import Model from "./components/Model";
import Footer from "./components/Footer";
import News from "./components/News";
import TeamPage from "./components/TeamPage";
import HeadlineBanner from "./components/HeadlineBanner";

const Home = () => (
  <div className="App">
    <HeadlineBanner />
    <Header />
    <main>
      <Hero />
      <FeaturedPlayer />
      <Rankings />
      <Spotlight />
      <News />
      <Model />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/team/:slug" element={<TeamPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
